import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class GraphEdgeValidation {
    recordExists: boolean;
    targetVertexNoPrimary: boolean;
    targetVertexMorePrimary: boolean;
    sourceVertexNoPrimary: boolean;
    sourceVertexMorePrimary: boolean;
}
